// The combined config for you environment will be available in the CONFIG global in your Javascript
module.exports = {
  supportTicketApi: 'https://ticket.hub.godaddy.com/api/v1/tickets',
  godaddyProDomain: 'pro.godaddy.com',
  optinApi: 'https://optin.pcx.godaddy.com/api',
  optOutRedirect: 'https://account.godaddy.com/products?go_redirect=disabled&pro_opt_out=true',
  proApi: 'https://api.hub.godaddy.com/api/v1',
  hubUrl: 'https://hub.godaddy.com',
  expertsApi: 'https://api.experts.godaddy.com/v1'
};
